export const NAMESPACE = "UISessionPageModule";

export const CONTENT_MODAL_ID = "MEDIA_CONTENT_INSTANCE_ID_SESSION_PAGE";

export const SESSION_MODAL_TABS_INSTANCE_ID = "session-page-tabs-instance-id";

export const TABS = {
  DRAFT: "draft",
  BASIC_DETAILS: "basicDetails",
  PARTICIPANTS: "participants",
  CONTENT: "content",
  SUBSESSIONS: "subsessions"
};

export const SUBSESSIONS_TAB = {
  SELECT_SESSIONS: "selectSessions",
  CONVERT_TO_SUBSESSIONS: "convertToSubsessions"
};

export const SUBSESSIONS_STEPS = ["Select Sessions", "Convert To Subsessions"];

export const TABS_CONTENT = [
  { title: "Details", key: "details", id: TABS.BASIC_DETAILS },
  { title: "Participants", key: "participants", id: TABS.PARTICIPANTS },
  { title: "Files", key: "file-content", id: TABS.CONTENT },
  { title: "Subsessions", key: "subsessions", id: TABS.SUBSESSIONS }
];

export const SESSION_FORM_ID = "SessionPageFormId";

export const DATE_FORMAT = "M/D [at] h:mma";

export const LOCATION_TYPE_IDS = {
  STAGE: "stage",
  ROOM: "room",
  BOOTH: "booth",
  NETWORKING: "networking",
  EXTERNAL: "external",
  BIDDING: "bidding",
  VIRTUAL: "virtual"
};

export const LOCATION_TYPES = [
  {
    id: LOCATION_TYPE_IDS.ROOM,
    label: "Room"
  },
  {
    id: LOCATION_TYPE_IDS.VIRTUAL,
    label: "Virtual"
  }
];

export const FIELD_IDS = {
  STATUS: "status",
  TAGS: "tags",
  LEVEL: "level",
  LANGUAGE: "language",
  CEU_CREDITS: "ceu_credits",
  TRACK: "track",
  FORMAT: "format",
  SPONSORS: "sponsors",
  EXHIBITORS: "exhibitors",
  SPEAKERS: "speakers",
  CHAIRPERSONS: "chairpersons",
  MODERATORS: "moderators",
  EMBEDS: "embeds",
  LOCATION: "location",
  BOOTH: "location_booth_id",
  ROOM: "location_room_id",
  LOCATION_ROOM: "location_room",
  STAGE: "location_stage_id",
  VIRTUAL: "session_location_type",
  LOCATION_EXTERNAL_URL: "location_external_url",
  SESSION_SUBMITTER: "session_submitter",
  CLIENT_SESSION_ID: "client_session_id",
  //
  TITLE: "title",
  DESCRIPTION: "description",
  STARTS_AT: "starts_at",
  ENDS_AT: "ends_at",
  BACKGROUND_IMAGE_URL: "background_image_url",
  VIDEO_URL: "video_url",
  VIDEO_TITLE: "video_title",
  CONFERENCE_URL: "conference_url",
  CONFERENCE_TITLE: "conference_title",
  TRANSCRIPT_URL: "transcript_url",
  REPLAY_URL: "replay_url",
  PARENTSESSIONID: "parentSessionId"
};

export const CONTENT_VIDEO = "videoContent";

export const NEXT_BTN_WIDTH_FOR_TAB_CONTENT = 268;
export const NEXT_BTN_WIDTH = 80;

export const VIRTUAL_TYPES_LABEL = {
  breakout: "Breakout",
  livestream: "Livestream",
  "on-demand": "On-Demand",
  external: "External"
};

export const SUBSESSION_ACTIONS = {
  unlink: "unlink",
  edit: "edit",
  delete: "delete"
};

export const MODULES_TINY_MCE =
  "table media link code lists image codesample eqneditor wordcount";
export const FORMATS_TINY_MCE =
  "bold italic underline | superscript subscript link eqneditor | bullist numlist outdent indent | image | removeformat | code | codesample";

export const FROM_SESSION_PAGE = "from_session_page";
